(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[782],{

/***/ 54858:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var e=__webpack_require__(95844),t=__webpack_require__(90005),o=__webpack_require__(27378);function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var a,d=/*#__PURE__*/r(t),n=/*#__PURE__*/r(o);exports.ButtonVariants=void 0,(a=exports.ButtonVariants||(exports.ButtonVariants={})).blue="blue",a.default="default",a.tab="tab",a.hollowBlue="hollowBlue";var l={blue:"bg-brand-700 text-white border-2 border-brand-700",default:"text-base  text-white;",tab:"text-base border-b-2 border-b-grey-600 text-grey-700 font-bold",hollowBlue:"bg-white text-brand-700 font-bold border-sm border-brand-700"},u={lg:"rounded-lg",xl:"rounded-xl",sm:"rounded-sm",md:"rounded-md",xs:"rounded-xs"},i=o.forwardRef(function(t,o){var r,a=t.rounded,i=void 0===a?"sm":a,s=t.variant,b=void 0===s?exports.ButtonVariants.default:s,f=t.onClick,c=void 0===f?function(){}:f,x=t.onMouseLeave,v=void 0===x?function(){}:x,m=t.dataTestId,p=t.disabled,w=void 0!==p&&p,y=t.startIcon,g=void 0===y?null:y,B=t.id,h=t.className,V=void 0===h?"":h,k=t.name,q=t.type,C=void 0===q?"button":q,M=t.children,N=t.mergeClasses,j=d.default(((r={})["inline-flex text-center justify-center items-center font-bold py-3 px-6 focus:outline-none"]=!0,r[l[b]]=!!b,r[u[i]]=!!i,r["disabled:opacity-25 cursor-not-allowed"]=!!w,r)),I=e.useTwMerge(j,V,N);return n.default.createElement("button",{"data-testid":m,ref:o,className:""+I,onClick:c,id:B,type:C,disabled:w,name:k,onMouseLeave:v},g,M)});i.displayName="Button",exports.Button=i;


/***/ }),

/***/ 90928:
/***/ (function(__unused_webpack_module, exports) {

!function(n,e){ true?e(exports):0}(this,function(n){n.If=function(n){var e=n.children;return!0===n.condition?"function"==typeof e?e():e:null}});


/***/ }),

/***/ 99165:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,a){ true?a(exports,__webpack_require__(95844),__webpack_require__(90005),__webpack_require__(27378)):0}(this,function(e,a,r,n){function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=/*#__PURE__*/t(r),o=/*#__PURE__*/t(n);function l(){return l=Object.assign?Object.assign.bind():function(e){for(var a=1;a<arguments.length;a++){var r=arguments[a];for(var n in r)({}).hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l.apply(null,arguments)}var s=o.default.forwardRef(function(e,r){var n,t=e.children,s=e.isOverlay,u=e.onClick,f=e.classNames,c=void 0===f?"":f,d=e.animationDuration,y=void 0===d?500:d,v=e.top,p=void 0===v?"":v,m=a.useDelayUnmount(s,y),b=i.default(((n={})["_Z2eg-"]=!0,n[""+c]=!!c,n.transition=!0,n._1I8b8=s,n["_06ju-"]=!s,n));return m?o.default.createElement("div",{style:l({animationDuration:y+"ms"},p?{top:p}:{}),"data-testid":"overlay",ref:r,onClick:u,className:b},t):null});s.displayName="Overlay",e.Overlay=s});


/***/ }),

/***/ 29891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(27378),__webpack_require__(31542)):0}(this,function(e,t,r){function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=/*#__PURE__*/n(t),u=/*#__PURE__*/n(r);e.Portal=function(e){var r=e.selector,n=e.children,c=t.useState(!1),a=c[0],d=c[1],f=t.useRef(null);return t.useEffect(function(){if(!document.querySelector("#"+r)){var e=document.createElement("div");e.setAttribute("id",r),document.body.appendChild(e)}f.current=document.querySelector("#"+r),d(!0)},[]),o.default.createElement(o.default.Fragment,null,a?u.default.createPortal(n,f.current):"")}});


/***/ }),

/***/ 83718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ cleartaxInstance; },
/* harmony export */   "LZ": function() { return /* binding */ mpBackend; },
/* harmony export */   "Q3": function() { return /* binding */ ticketServiceBackend; },
/* harmony export */   "UF": function() { return /* binding */ appInstance; },
/* harmony export */   "u9": function() { return /* binding */ finfoAInstance; },
/* harmony export */   "x1": function() { return /* binding */ bifrostLayer; }
/* harmony export */ });
/* unused harmony export businessHiearchy */
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90849);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27833);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53201);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80144);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57807);
/* provided dependency */ var process = __webpack_require__(27061);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var finfoAInstance = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: "https://cleartax.in/f/"
});
finfoAInstance.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status);
  }

  return Promise.reject(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data.errorResponse', {
    message: '',
    code: ''
  }));
});
var cleartaxInstance = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: "https://cleartax.in/",
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});
var bifrostLayer = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: "https://cleartax.in/",
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'content-type': 'application/json'
  }
});
cleartaxInstance.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response2;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status);
  }

  return Promise.reject(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data.message', {
    message: '',
    code: ''
  }));
});
bifrostLayer.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response3;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.status);
  }

  return Promise.reject(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data.message', {
    message: '',
    code: ''
  }));
});
var appInstance = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: _constants__WEBPACK_IMPORTED_MODULE_2__/* .CLEARTAX_DOMAIN */ .nX,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
  responseType: 'blob'
});
var mpBackend = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: "https://cleartax.in/wg-routes/marketplace/api/",
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});
var ticketServiceBackend = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: "https://cleartax.in/wg-routes/ticket-service/api/",
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});
var businessHiearchy = axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
  baseURL: process.env.NEXT_PUBLIC_BUSINESS_HIERARCHY,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
    'Accept': 'application/json',
    'x-workspace-id': '2',
    'x-cleartax-product': 'CONSUMER_ITR',
    'Cookie': 'sid=1.300eed90-ff16-4aed-b71c-8139aa9361b3_9c99cc979e8099639105d96b5b5fb051dcb5897797f5cd5533524205ceda0863'
  }
});
businessHiearchy.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response4;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.status);
  }

  var mpBackendError = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data', {
    message: '',
    code: ''
  });
  return Promise.reject(_objectSpread(_objectSpread({}, mpBackendError), {}, {
    errorObj: err
  }));
});
mpBackend.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response5;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response5 = err.response) === null || _err$response5 === void 0 ? void 0 : _err$response5.status);
  }

  var mpBackendError = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data', {
    message: '',
    code: ''
  });
  return Promise.reject(_objectSpread(_objectSpread({}, mpBackendError), {}, {
    errorObj: err
  }));
});
ticketServiceBackend.interceptors.response.use(function (res) {
  return Promise.resolve(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(res, 'data', null));
}, function (err) {
  if (!err.response || !err.response.status || err.response.status >= 500) {
    var _err$response6;

    (0,_error__WEBPACK_IMPORTED_MODULE_3__/* .uncaughtApiError */ .tt)(err, (_err$response6 = err.response) === null || _err$response6 === void 0 ? void 0 : _err$response6.status);
  }

  var mpBackendError = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(err, 'response.data', {
    message: '',
    code: ''
  });
  return Promise.reject(_objectSpread(_objectSpread({}, mpBackendError), {}, {
    errorObj: err
  }));
});


/***/ }),

/***/ 57807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yv": function() { return /* binding */ handleMpBackendError; },
/* harmony export */   "au": function() { return /* binding */ WebsiteError; },
/* harmony export */   "tt": function() { return /* binding */ uncaughtApiError; }
/* harmony export */ });
/* unused harmony export somethingTerriblyWentWrong */
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43350);
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80040);
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39964);
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94182);
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3117);
/* harmony import */ var _opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13400);
/* harmony import */ var _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30858);
/* harmony import */ var _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60074);







function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




/**
 * Custom error class for website errors that inherits from the built-in Error class.
 *
 * @extends {Error}
 */
var WebsiteError = /*#__PURE__*/function (_Error) {
  (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WebsiteError, _Error);

  var _super = _createSuper(WebsiteError);

  /**
   * Creates an instance of WebsiteError.
   *
   * @param {Error} error - The error that caused the website error.
   */
  function WebsiteError(error) {
    var _this;

    (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, WebsiteError);

    _this = _super.call(this, error.message);
    _this.name = error.name || error.message;
    _this.cause = error.cause || null;
    return _this;
  }
  /**
   * Captures the error and sends it to Sentry.
   *
   * @returns {this}
   */


  (0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WebsiteError, [{
    key: "capture",
    value: function capture() {
      var _this2 = this;

      _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .withScope */ .$e(function (scope) {
        scope.setContext('extra-data', _this2.cause);
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(_this2);
      });
      return this;
    }
    /**
     * Displays the error message in a toaster component.
     *
     * @param {string} [message] - The message to display in the toaster. If not provided, the error's message will be used.
     * @returns {this}
     */

  }, {
    key: "withToaster",
    value: function withToaster(message) {
      _cleartax_wg_library_toast__WEBPACK_IMPORTED_MODULE_2__.Toster.Error(message ? message : this.message);
      return this;
    }
  }]);

  return WebsiteError;
}( /*#__PURE__*/(0,_opt_cleartax_mp_website_node_modules_next_dist_compiled_babel_runtime_helpers_esm_wrapNativeSuper_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(Error));
var uncaughtApiError = function uncaughtApiError(err, statusCode, serviceName) {
  var errorName = "".concat(serviceName || '', " Api Failed With ").concat(statusCode ? statusCode + ' Response' : 'without response', " ");
  var error = new WebsiteError(err);
  error.name = errorName;
  error.cause = err.response || [];
  error.capture().withToaster('Server Error');
};
var somethingTerriblyWentWrong = function somethingTerriblyWentWrong(err) {
  var errorName = 'Something terribly went wrong!';
  var error = new WebsiteError({
    message: err.message || 'ErrorMessage',
    name: err.errorObj.name || 'WebsiteError'
  });
  error.name = errorName;
  error.capture().withToaster('Server Error');
};
var handleMpBackendError = function handleMpBackendError(err) {
  var errorObj = err.errorObj;

  if (!errorObj) {
    somethingTerriblyWentWrong(err);
    return;
  }

  if (errorObj.response && errorObj.response.status >= 500) {
    uncaughtApiError(errorObj, errorObj.response.status);
    return;
  }

  if (errorObj.response) {
    uncaughtApiError(errorObj, errorObj.response.status);
    return;
  }

  if (errorObj.request) {
    uncaughtApiError(errorObj);
    return;
  }

  somethingTerriblyWentWrong(err);
};

/***/ }),

/***/ 47174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ds": function() { return /* reexport */ utils_utils/* debounce */.Ds; },
  "Tt": function() { return /* reexport */ utils_utils/* getApiParamsString */.Tt; },
  "pi": function() { return /* reexport */ utils_utils/* getCommaFormat */.pi; },
  "_X": function() { return /* reexport */ utils_utils/* getCurrencyFromUnicode */._X; },
  "$p": function() { return /* reexport */ utils_utils/* getDateDiffInDays */.$p; },
  "RR": function() { return /* reexport */ utils_utils/* getDateDiffInHours */.RR; },
  "$S": function() { return /* reexport */ utils_utils/* getPageLoader */.$S; },
  "bt": function() { return /* reexport */ postLeadsToFinfo; },
  "Uy": function() { return /* reexport */ utils_utils/* productFromProctServiceType */.Uy; },
  "lv": function() { return /* reexport */ utils_utils/* randomIntFromInterval */.lv; },
  "X2": function() { return /* reexport */ trackAction; }
});

// UNUSED EXPORTS: getCurrentFiscalYear, resolveServerSideProps, throttle

// EXTERNAL MODULE: ../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(90849);
// EXTERNAL MODULE: ../node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(53201);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ./src/config/axios.ts
var axios = __webpack_require__(83718);
;// CONCATENATED MODULE: ./src/shared/utils/leads/utils.ts
var isWebMobile = function isWebMobile() {
  if (navigator && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return 'mobile';
  }

  return 'web';
};
;// CONCATENATED MODULE: ./src/shared/utils/leads/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var getLeadPayload = function getLeadPayload(leadValues) {
  var _leadValues$leadType;

  var _leadValues$userName = leadValues.userName,
      userName = _leadValues$userName === void 0 ? leadValues.email : _leadValues$userName,
      _leadValues$productNa = leadValues.productName,
      productName = _leadValues$productNa === void 0 ? 'Callback' : _leadValues$productNa,
      _leadValues$whatsapp_ = leadValues.whatsapp_consent,
      whatsapp_consent = _leadValues$whatsapp_ === void 0 ? 'false' : _leadValues$whatsapp_,
      _leadValues$city = leadValues.city,
      city = _leadValues$city === void 0 ? '' : _leadValues$city,
      _leadValues$note = leadValues.note,
      note = _leadValues$note === void 0 ? 'v2 FE' : _leadValues$note;
  return {
    leadPlatforms: {
      lsq: _objectSpread({},  true && {
        add_lead: true
      })
    },
    leadData: {
      type: 'marketplace-order-form',
      data: {
        leadType: ((_leadValues$leadType = leadValues.leadType) === null || _leadValues$leadType === void 0 ? void 0 : _leadValues$leadType.toUpperCase()) || 'CATEGORY',
        user_type_form: 'Marketplace',
        name: userName,
        user_device: isWebMobile(),
        phone_number: leadValues.phoneNumber,
        email: leadValues.email,
        value: leadValues.value ? leadValues.value : 0,
        product_selected: leadValues.productName,
        lead_source_page: lodash_get_default()(document, ['title'], productName) || productName,
        lead_source_url: lodash_get_default()(window, ['location', 'href'], ''),
        reference_url: lodash_get_default()(document, ['refferer'], ''),
        note: leadValues.note ? leadValues.note : note,
        lead_creation_time: Math.floor(new Date().getTime() / 1000),
        city: city,
        whatsapp_consent: whatsapp_consent
      }
    }
  };
};
var postLeadsToFinfo = function postLeadsToFinfo(leadPayload) {
  return axios/* finfoAInstance.post */.u9.post("common-lead/common-add-lead", getLeadPayload(leadPayload)).then(function (data) {
    return data;
  })["catch"](function (error) {
    return console.info('Lead failed :', error);
  });
};
// EXTERNAL MODULE: ../mp-library/packages/utils/dist/index.js
var dist = __webpack_require__(40068);
// EXTERNAL MODULE: ../node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(29194);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(80144);
// EXTERNAL MODULE: ./src/shared/utils/tracker/configs.ts
var configs = __webpack_require__(16466);
// EXTERNAL MODULE: ./src/shared/utils/tracker/utils.ts
var utils = __webpack_require__(7244);
;// CONCATENATED MODULE: ./src/shared/utils/tracker/index.ts


function tracker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tracker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tracker_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tracker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // For now we are assuming we get an object of this shape
// We can create a util function to create this object
// using global state within the upstream consumer.

var trackAction = function trackAction(action, value) {
  var trackContextObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var category = arguments.length > 3 ? arguments[3] : undefined;
  var emailid = trackContextObject.emailid,
      prevLocation = trackContextObject.prevLocation,
      label = trackContextObject.label; // create dataMap

  var v2Category = category ? category : 'mp-website-v2';
  var anonId = (0,lib.getCookie)('anon_id');

  var dataMap = tracker_objectSpread(tracker_objectSpread({
    category: configs/* CATEGORY_MARKETPLACE_WEBSITE */.kq,
    label: label ? label : window ? window.location.pathname : '',
    original_referrer: (0,utils/* getPrevLocation */.ni)(prevLocation ? prevLocation : ''),
    anonid: anonId ? anonId : 'anoynomous',
    _ay: configs.AY,
    _t: new Date().getTime(),
    action: v2Category ? "".concat(action, "_").concat(v2Category) : action,
    email: emailid ? emailid : dist.StorageUtil.getItem(constants/* SESSION_STORAGE_KEYS.USERNAME */.sO.USERNAME)
  }, (0,utils/* getUTMParameters */.Vo)()), value ? tracker_objectSpread({}, (0,utils/* getAdditionalDataFromValue */.v6)(value)) : {});

  (0,utils/* sendFunnelMetrics */.nV)((0,utils/* getFunnelMetricParamsFromObject */.dz)(dataMap).join('&'));
  (0,utils/* handleConversions */.hH)(action);
  (0,utils/* trackActionGA4 */.JR)(action, dataMap);
};
// EXTERNAL MODULE: ./src/shared/utils/utils/index.tsx
var utils_utils = __webpack_require__(87353);
;// CONCATENATED MODULE: ./src/shared/utils/index.ts




/***/ })

}]);